/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  updateLogo(file) {
    const formData = new FormData();
    formData.append('logo', file);
    return axios.patch(
      `/api/v1/accounts/${this.accountIdFromRoute}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  deleteLogo() {
    return axios.delete(`/api/v1/accounts/${this.accountIdFromRoute}/logo`);
  }
}

export default new AccountAPI();
